<template>
    <div class="autocomplete-groups">

        <v-alert
                type="error"
                v-model="alert"
                dismissible
        >
            No group selected. Please select a group first.
        </v-alert>

        <v-autocomplete
                v-model="group"
                @change="viewSelectedGroupDetails"

                :items="items"
                :loading="isLoading"
                :search-input.sync="search"
                :filter="customFilter"

                item-text="name"
                item-value="name"

                autofocus
                clearable

                label="Groups"
                placeholder="Start typing to Search"
                prepend-icon="mdi-database-search"
                return-object
        >
            <template v-slot:append-outer>
                <v-btn
                        icon
                        color="primary"
                        @click="viewSelectedGroupDetails"
                >
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </template>
        </v-autocomplete>
    </div>
</template>
<script>
    import GroupsAPI from '@/services/api/ABTesting/Groups';

    export default {
        name: 'GroupsAutocomplete',

        data: () => ({
            group: null,
            alert: false,
            entries: [],
            isLoading: false,
            search: null,
        }),

        computed: {
            items() {
                return this.entries.map(entry => {
                    return Object.assign({}, entry.data)
                })
            },
        },

        watch: {
            search(val) {

                // On empty search
                if (val === '' || val === null) {

                    this.entries = []
                    this.isLoading = false
                    clearTimeout(this._searchTimerId)

                    return
                }

                const searchDelay = 300 //ms
                this.isLoading = true

                clearTimeout(this._searchTimerId)
                this._searchTimerId = setTimeout(() => {

                    GroupsAPI.getGroups(val)
                        .then(response => {
                            this.entries = response.collection
                        })
                        .catch(err => {
                            console.log(err)
                        })
                        .finally(() => (this.isLoading = false))
                }, searchDelay)
            },
        },

        methods: {
            customFilter(item, queryText/*, itemText*/) {
                const parts = queryText.split(' ')
                for (let part of parts) {
                    if (item.name.indexOf(part) === -1) {
                        return false
                    }
                }
                return true
            },

            viewSelectedGroupDetails() {
                if (!this.group) {
                    this.alert = true
                    return
                }
                this.$router.push('/group/' + this.group.name)
            }
        }
    }
</script>
